import axios from 'axios'

import { SERVER_URL } from 'Global/constants'

const defaultHeaders = user => ({ Authorization: `JWT ${user.token}` })

const apiMiddleware = ({ dispatch, getState }) => next => action => {
  if (!action.type.startsWith('API|') || !action.meta) {
    return next(action)
  }

  const { meta, type } = action
  const { user } = getState().auth

  const {
    appendToActions,
    data,
    errorMessage,
    externalUrl,
    fulfilled = `FULFILLED_${type}`,
    headers,
    method = 'get',
    params,
    pending = `PENDING_${type}`,
    rejected = `REJECTED_${type}`,
    responseType,
    successMessage,
    url,
  } = meta

  dispatch({ meta: { ...appendToActions }, type: pending })

  axios({
    data: data,
    headers: { ...defaultHeaders(user), ...headers },
    method,
    params,
    responseType,
    url: externalUrl ? externalUrl : `${SERVER_URL}${url}`,
  })
    .then(res => res.data)
    .then(data =>
      dispatch({
        meta: { ...appendToActions, successMessage },
        payload: { data },
        type: fulfilled,
      }),
    )
    .then(() => next(action))
    .catch(err => {
      console.error(err) // eslint-disable-line no-console

      dispatch({
        meta: { ...appendToActions, errorMessage, url },
        type: rejected,
      })
    })
}

export default apiMiddleware
